"use client";

import dynamic from "next/dynamic";

export const CtaOnLeave = dynamic(
  () =>
    import("~/components/common/cta/on-leave").then((mod) => ({
      default: mod.CtaOnLeave,
    })),
  { ssr: false },
);
